export default __webpack_public_path__ + "static/media/Comp_3.395e4b85.gif";